import React from "react";
import { Form, Button, Row, Col } from "antd";
import { ConsentFormStep1 } from "./ConsentStep1.js";
import { withNamespaces } from "react-i18next";
import { getSitesRequest } from "../../api/requests";

class Consent extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      sites: [],
    };
  }

  async componentDidMount() {
    try {
      const { data } = await getSitesRequest({consent_active: true});
      this.setState({ sites: data });
    } catch (e) {
      if (e.response.status === 401) {
        return;
      }
      console.log(e);
    }

    this.setState({
      isSitesLoading: false,
    });
  }

  handleNext = (e) => {
    e.preventDefault();

    this.props.form.validateFields((err, values) => {
      if (!err) {
        values["currentStepInt"] = this.props.currentStepInt;
        values["currentStep"] = this.props.currentStep;
        this.props.handleNext(values);
      }
    });
  };

  nextButton() {
    return (
      <Form.Item>
        <Button
          size="large"
          type="primary"
          loading={this.props.loading}
          onClick={this.handleNext}
        >
          {this.props.i18n.t("Next")}
        </Button>
      </Form.Item>
    );
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { loading } = this.props;

    return (
      <Row type="flex" justify="center">
        <Col xs={24} sm={18} md={18} lg={20} xl={22} className="frosted-card">
          <h2>
            {this.props.i18n.t("Consent")} - {this.props.currentStep}
          </h2>
          <Form onSubmit={this.handleSubmit} autoComplete='nope'>
            {/*
              Step 1 - user enters userID, siteID, subjectID
              Step 2 - verifies that userID, siteID are valid, that the subject exists, and if they already have consent entered
                       also asks for consentPersonType and consentMethodType
              Step 3a - paper consent form with download link and upload button; Patient and Surrogate versions
              Step 3b - electronic consent form
              Step 4 - Confirmation of consent process and Link to view stored document
            */}
            <ConsentFormStep1
              sites={this.state.sites}
              currentStep={this.props.currentStep}
              currentStepInt={this.props.currentStepInt}
              handleChange={this.props.handleChange}
              subjectID={this.props.subjectID}
              userID={this.props.userID}
              siteID={this.props.siteID}
              loading={this.props.loading}
              getFieldDecorator={getFieldDecorator}
              consentRandomization={this.props.consentRandomization}
            />

            {this.nextButton()}
          </Form>
          <p>&nbsp;</p>
        </Col>
      </Row>
    );
  }
}

const ConsentForm = Form.create()(withNamespaces()(Consent));

export default ConsentForm;



// WEBPACK FOOTER //
// ./src/components/Consent/ConsentSteps.js